import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["searchField", "productRow"]

  filter() {
    const searchTerm = this.searchFieldTarget.value.toLowerCase()
    
    this.productRowTargets.forEach(row => {
      const productName = row.dataset.productName
      if (productName.includes(searchTerm)) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }
}